import CommentForm from './CommentForm';
import './CommentForm.scss';

export default CommentForm;
